"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEMS_COUNTER_SKELETON = void 0;
const ITEMS_COUNTER_SKELETON = exports.ITEMS_COUNTER_SKELETON = 'items-counter-skeleton';
